import { Box, Flex } from 'grid-styled'
import * as React from 'react'
import Layout from '../../components/Layout'
import Img from 'gatsby-image'
import { graphql, Link } from 'gatsby'

import CTA from '../../components/CTA'

import {
  Announcement,
  Container,
  Hero,
  HeroContent,
  HeroFigure,
  HeroMain,
  SplitSection,
  SplitFigure,
  SplitContent,
  Text,
  ReadMore,
  ServiceCard
} from '../../components/styles'
import { Button } from '../../components/Button'
import FAQs from '../../components/FAQs'
import Form from '../../components/Form'
import { SocialCases } from '../../components/case-studies/SocialCases'
import Arrow from '../../components/Arrow'
import Testimonials from '../../components/Testimonials'
import { testimonials } from '../testimonials'
import { Helmet } from 'react-helmet'

export const faqsInfo = [
  {
    title: 'Common social media questions'
  },
  {
    answer: `Every day, we help businesses in every industry and of every size get more traffic, more conversion and a radical increase in sales and high quality customers. We're proud of our track record of producing great tangible results for our partners.`,
    question: 'Does social media work?'
  },
  {
    answer: `Your business is one of a kind, and there are many factors at play. Each platform comes with it's own unique benefits and primary demographics. The channels that are most suited to your business needs depends entirely on your strategy and goals. That being said, we always recommend the two biggest social media platforms in the world: Facebook, and Instagram.`,
    question: `Which social media channels are best for my business?`
  },
  {
    answer: `Of course. Our regular reporting will keep you up to date on the metrics you care about. You'll recieve information on the impacts of our content marketing and organic efforts and exact numbers for social advertising reults. We strive to be transparent in everything we do.`,
    question: `Will you be able to prove your social media ROI?`
  },
  {
    answer: `Well, strategy is number one! Following this we're experts in execution: graphic design, writing, content delivery, landing page creation, website optimisations, social competitions, and post curation are all in our reach. We'll pick what's best for you business and pursue it relentlessly.`,
    question: `What kind of social media work can we expect from you?`
  }
]

/* prettier-ignore */
interface IProps {
  data: {
    audit: {
      childImageSharp: {
        fluid: object
      }
    };
    soh: {
      childImageSharp: {
        fluid: object
      }
    };
    setup: {
      childImageSharp: {
        fluid: object
      }
    };
    hero: {
      childImageSharp: {
        fluid: object
      }
    };
  }
}

export default ({ data }: IProps) => (
  <Layout>
    <Helmet>
      <title>
        Social Media Marketing Brisbane - Facebook & Instagram - Turboclicks
      </title>
      <meta
        name="description"
        content="We help businesses tangibly grow their business sales through effective and modern SEO practices. Don't miss out on the world's largest marketplace."
      />
    </Helmet>
    <Hero>
      <Container>
        <HeroContent>
          <HeroMain>
            <h1>Social media marketing Brisbane</h1>
            <p>
              Every single online act and decision has an impact on whether a
              user becomes a paying customer or goes to your competitor.
            </p>
            <Announcement to="/contact">
              Speak with a social specialist
              <Arrow rotate="-90deg" />
            </Announcement>
            <Link to="/contact#form">
              <Button inverted={true}>Help me get results</Button>
            </Link>
          </HeroMain>

          <HeroFigure>
            <Img
              fluid={data.hero.childImageSharp.fluid}
              alt="Turboclicks website development in Brisbane"
            />
          </HeroFigure>
        </HeroContent>
      </Container>
    </Hero>

    <Container
      bg="#f1f8fe"
      padY={true}
      medium={true}
      style={{ borderRadius: 4 }}
    >
      <Flex mb={5} justifyContent="center">
        <h4>Social Media Services</h4>
      </Flex>
      <ServiceCard color="primary">
        <img
          src="//truework.com/images/line-illustrations/background-check-056dd30e.svg"
          alt="Mortgage illustration"
        />
        <div>
          <h3>Social Organic</h3>
          <p>
            There's more to social media than just posting a photo every 2
            weeks. We understand each platform's complexities and the
            psychological motives of your followers. This allows us to optimise
            pages, target platforms, and create the ultimate strategy for your
            individual position.
          </p>
        </div>
      </ServiceCard>
      <ServiceCard color="tertiary">
        <img
          src="//truework.com/images/line-illustrations/mortgage-734d5e32.svg"
          alt="Mortgage illustration"
        />
        <div>
          <h3>Facebook &amp; Instagram Ads</h3>
          <p>
            Fact, more than 35% of Australian social media users check their
            accounts more over 5 times per day? This makes social media, and
            Facebook in particular a giant of user attention and eyeballs. If
            you're not yet advertising on social media then your missing one of
            the biggest customer playgrounds in the world, maybe in human
            history.
          </p>
        </div>
      </ServiceCard>
      <ServiceCard color="purple">
        <img
          src="//truework.com/images/line-illustrations/background-check-056dd30e.svg"
          alt="Mortgage illustration"
        />
        <div>
          <h3>Content Marketing</h3>
          <p>
            People won't follow an account that posted an inspriational quote 6
            months ago. People trust brands that engage with them and the world
            more regularly. We have a team of writers and graphic designers
            capable of producing relevant and high quality unique content. Why
            not reach out and say hi.
          </p>
        </div>
      </ServiceCard>
    </Container>

    <Box mt={5} />

    <CTA
      inverted={true}
      title="Don't miss the social revolution"
      subtitle="Find out how we can help"
      button="Speak to a specialist"
    />

    <Container padY={true} medium={true}>
      <SplitSection>
        <SplitFigure>
          <Img
            fluid={data.setup.childImageSharp.fluid}
            alt="Statistics and website development audit"
          />
        </SplitFigure>
        <SplitContent>
          <h2>Just starting with social?</h2>
          <p>
            If you don't yet have a Facebook page for your business, let us take
            care of the boring setup work. We've set up social media accounts
            for some of Brisbane's most prolific social media brands.
          </p>
          <ReadMore to="/contact">
            See what we can do <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>

      <SplitSection alternate={true} padY={true}>
        <SplitFigure>
          <Img
            fluid={data.audit.childImageSharp.fluid}
            alt="Wireframes and user flows for website"
          />
        </SplitFigure>
        <SplitContent>
          <h2>Already have an online presence?</h2>
          <p>
            You might have a Facebook page. But do you really have presence? If
            you think that your page could be improved, why not find out for
            sure... Just ask our team to do a full review and create a
            recommendation report specifically for your business.
          </p>
          <ReadMore to="/contact">
            Get your report now <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>
    </Container>

    <Container medium={true}>
      <h3>The importance of social marketing</h3>

      <h5>Attention and eyeballs</h5>
      <Text size="large">
        Think about the largest physical marketplace in the world, Facebook
        alone is thousands of time bigger. Last year it had over 2.2 billion
        active users of the platform. These are people who are looking for your
        service, and now you know where to find them. These ads work, with the
        right strategy and execution social media could become one of the
        cornerstones of your marketing process.
      </Text>

      <h5>Web proliferation</h5>
      <Text size="large">
        Nowadays, if you're not infront of your customers. They will quickly and
        ruthlessly forget about you. Did you know that most customers will buy
        or convert after seeing your business 7 times. That means the more you
        can get your brand out there in a targetted fashion, the more sales you
        will have.
      </Text>
      <Text size="large">
        These statistics shouldn't alarm your. With the right strategy, you can
        turn this to your advatage and have your business in front of the most
        qualified customers on the internet.
      </Text>

      <h5>Part of the whole</h5>
      <Text size="large">
        You can't have a complete digital growth strategy with the social media
        element. It's really that simple. It's like driving a car with only 3
        tyres. Our experience with social and digital growth strategy will help
        take your business to the next level.
      </Text>

      <h5>An untapped advertising resource</h5>
      <Text size="large">
        Even now, 95% of business don't do any form of social media advertising.
        Imagine being able to advertise to anyone on in Australia, literally
        anyone, and be able to customise and target the ad to them. This is the
        potential of social advertising.
      </Text>
      <Text size="large">
        We've seen the overwhelming results of Facebook and Instagram
        advertising, two of the largest social platforms in the world. Whether
        promoting your business, remarketing to qualified leads, or building
        brand awareness for cents instead of dollars. We've helped businesses
        just like yours utilise this overwhelmingly powerful tool.
      </Text>
    </Container>

    <FAQs data={faqsInfo} />

    <SocialCases image={data.soh.childImageSharp.fluid} />

    <Testimonials testimonials={testimonials} />

    <Form />
  </Layout>
)

export const query = graphql`
  query SocialPageQuery {
    hero: file(relativePath: { eq: "turboclicks-social-media-marketing.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    setup: file(relativePath: { eq: "social-media-setup.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    soh: file(relativePath: { eq: "turboclicks-smartonhold-case.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    audit: file(relativePath: { eq: "brisbane-social-media-audit.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
